import React from "react";
import {Typography, Box, IconButton, Button, Card, CardActions, CardContent, CardMedia, CssBaseline} from "@mui/material";
import Grid from '@mui/material/Grid2';
import {X, Instagram, YouTube, LinkedIn} from "@mui/icons-material";
import Steam from ".//images/steam_logo.svg";
import './App.css';
import Logo from ".//images/Logo.png";
import LogoPeople from ".//images/LogoPeople.png";
import WishlistLogo from "./images/wl.png"; // Sol PNG
import King from "./images/king.png"; // Sol PNG
import HidenHeistLogo from "./images/hnh-logo.png";   // Sağ alt PNG
import Kray from "./images/persons/kray.png";
import Koray from "./images/persons/koray.png";
import Alp from "./images/persons/alp.png";
import Didem from "./images/persons/didem.png";
import Ali from "./images/persons/ali.png";
import Aykut from "./images/persons/aykut.png";
import Enes from "./images/persons/enes.png";
import {createTheme, ThemeProvider} from '@mui/material';

const App = () => {

    const theme = createTheme({
        typography: {
            fontFamily: ['Kurale'],
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        overflow: 'hidden', // Scroll barını devre dışı bırakır
                    },
                },
            },
        },
    });

    // Sayfayı kaydırma fonksiyonu
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            window.scrollTo({
                top: section.offsetTop,
                behavior: 'smooth', // Kaydırma animasyonu
            });
        }
    };

    const team = [
        { name: "Eray Kırkpınar", role: "Game Developer", image: Kray },
        { name: "Koray Kayan", role: "Level Designer", image: Koray },
        { name: "Didem T. Şahin", role: "UI Artist", image: Didem },
        { name: "Ali Eren Gül", role: "Game Designer", image: Ali },
        { name: "Mehmet Aykut Yar", role: "Game Developer", image: Aykut },
        { name: "Enes Yaman", role: "Sound Designer", image: Enes },
        { name: "Metin Alp Kocaman", role: "Marketing Manager", image: Alp },
    ];

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div style={{position: 'relative', overflow: 'hidden'}}>
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100vh",
                    background: "radial-gradient(circle, #f0543f 5%, #15182b 100%)",
                    zIndex: -1,
                }}></div>
                {/* Logo */}
                <Grid container spacing={3} sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}>
                    <Grid size={{xs: 4, md: 7}}
                          sx={{display: {xs: 'none', sm: 'block', md: 'block'}, marginRight: "20px"}}>
                        <Box
                            style={{
                                position: "fixed",
                                paddingTop: "20px",
                                paddingLeft: "20px",
                                zIndex: 1000,
                            }}
                        >
                            <img
                                src={Logo}
                                alt="Logo"
                                style={{
                                    height: "50px",
                                    paddingLeft: "50px",
                                    filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))"
                                }}
                            />
                        </Box>
                    </Grid>
                    {/* Navigation Buttons */}
                    <Grid size={{sm: 6, md: 4, xl: 3}}>
                        <Box
                            style={{
                                position: "fixed",
                                paddingTop: "20px",
                                display: "flex",
                                gap: "4px",
                                zIndex: 1000,
                            }}
                        >
                            <Button onClick={() => scrollToSection('home')} color="inherit"
                                    style={{color: "#f3ecd8", fontWeight: "bold"}}>Home</Button>
                            <Button onClick={() => scrollToSection('hide-n-heist')} color="inherit"
                                    style={{color: "#f3ecd8", fontWeight: "bold"}}>Hide n Heist</Button>
                            <Button onClick={() => scrollToSection('about')} color="inherit"
                                    style={{color: "#f3ecd8", fontWeight: "bold"}}>About Us</Button>
                            <Button onClick={() => scrollToSection('contact')} color="inherit"
                                    style={{color: "#f3ecd8", fontWeight: "bold"}}>Contact</Button>
                        </Box>
                    </Grid>
                </Grid>
                {/* Hero Section */}
                <Grid container spacing={3}
                      sx={{
                          justifyContent: "center",
                          alignItems: "center",
                      }}>
                    <Grid size="grow">
                        <Box
                            id="home"
                            style={{
                                height: "100vh",
                                display: "flex",
                                flexDirection: "row", // Yatay yerleşim için
                                alignItems: "center",
                                justifyContent: "center",
                                position: "relative",
                                gap: theme.spacing(24)
                            }}
                        >
                            {/* HELLO Text */}
                            <Box style={{textAlign: "center"}}>
                                <Typography variant="h2"
                                            style={{color: "#15182b", fontWeight: "bold", marginBottom: "10px"}}>
                                    HELLO
                                </Typography>
                                <Typography variant="h6" style={{color: "#15182b", fontWeight: "bold"}}>
                                    We are doin' something together.
                                </Typography>
                                {/* Social Media Icons */}
                                <Box style={{
                                    marginTop: "30px",
                                    display: "flex",
                                    gap: "15px",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <IconButton
                                        href="https://store.steampowered.com/app/3321300/Hide_n_Heist/"
                                        target="_blank"
                                        style={{
                                            backgroundColor: "#f3ecd8",
                                            borderRadius: "12px",
                                            padding: "10px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                        }}
                                    >
                                        <img src={Steam} height={25} style={{color: "#15182b"}}/>
                                    </IconButton>
                                    <IconButton
                                        href="https://www.instagram.com/dointogethergames/"
                                        target="_blank"
                                        style={{
                                            backgroundColor: "#f3ecd8",
                                            borderRadius: "12px",
                                            padding: "10px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                        }}
                                    >
                                        <Instagram style={{color: "#15182b"}}/>
                                    </IconButton>
                                    <IconButton
                                        href="https://x.com/dointogether"
                                        target="_blank"
                                        style={{
                                            backgroundColor: "#f3ecd8",
                                            borderRadius: "12px",
                                            padding: "10px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                        }}
                                    >
                                        <X style={{color: "#15182b"}}/>
                                    </IconButton>
                                    <IconButton
                                        href="https://www.youtube.com/@DoinTogether"
                                        target="_blank"
                                        style={{
                                            backgroundColor: "#f3ecd8",
                                            borderRadius: "12px",
                                            padding: "10px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                        }}
                                    >
                                        <YouTube style={{color: "#15182b"}}/>
                                    </IconButton>
                                    <IconButton
                                        href="https://www.linkedin.com/company/dointogethergames/"
                                        target="_blank"
                                        style={{
                                            backgroundColor: "#f3ecd8",
                                            borderRadius: "12px",
                                            padding: "10px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                        }}
                                    >
                                        <LinkedIn style={{color: "#15182b"}}/>
                                    </IconButton>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                {/* Hide n Heist Section */}
                <Grid container spacing={3}
                      sx={{
                          justifyContent: "center",
                          alignItems: "center",
                      }}>

                    <Box
                        id="hide-n-heist"
                        style={{
                            height: "100vh",
                            display: "flex",
                            flexDirection: "row", // Yatay yerleşim için
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            gap: theme.spacing(18)
                        }}
                    >
                        <Grid size="grow" sx={{display: {xs: 'none', lg: 'inline', xl: 'inline'}, height: {xs: '0px', lg: '250px', xl: '450px'}}}>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <img
                                    src={HidenHeistLogo}
                                    alt="Example"
                                    style={{height: "300px", filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))"}}
                                />
                                <Button
                                    href="/presskit"
                                    color="inherit"
                                    style={{
                                        color: "#f3ecd8",
                                        fontWeight: "bold",
                                        fontSize: "18px",
                                        marginTop: "10px",
                                        backgroundColor: "rgba(21, 24, 43, 0.2)",  // Increased opacity for better visibility
                                        padding: "10px 20px",  // Slightly larger padding to accommodate bigger font
                                        borderRadius: "4px"
                                    }}
                                >
                                    Press Kit
                                </Button>
                            </Box>
                        </Grid>
                        <Grid size="grow">
                        {/* YouTube Video */}
                        <Box style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))"
                        }}>
                            <a href={"https://store.steampowered.com/app/3321300/Hide_n_Heist/"}>
                                <img
                                    src={WishlistLogo}
                                    alt="Hide n Heist Logo"
                                    style={{
                                        marginBottom: "-4px",
                                        height: "250px",
                                        filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))"
                                    }}
                                />
                            </a>
                            <div style={{
                                position: "relative",
                                overflow: "hidden",
                                width: "100%",
                                paddingTop: "56.25%",
                            }}>
                            <iframe
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0,
                                    width: "100%",
                                    height: "100%",
                                }}
                                src="https://www.youtube.com/embed/zeOtz5MSYrM"
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>

                            </div>
                            <Typography variant="h6"
                                        style={{
                                            color: "#15182b",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            maxWidth: "600px",
                                            marginTop: "20px"
                                        }}>
                                We are a passionate game studio dedicated to creating unique and enjoyable experiences
                                for
                                players around the world.
                            </Typography>
                        </Box>
                        </Grid>
                        <Grid size="grow" sx={{display: {xs: 'none', lg: 'inline', xl: 'inline'}, height: {xs: '0px', lg: '250px', xl: '450px'}}}>
                        <img
                            src={King}
                            alt="King"
                            style={{maxHeight: "450px", filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))"}}
                        />
                        </Grid>
                    </Box>
                </Grid>

                {/* About Us Section */}
                <Box
                    id="about"
                    sx={{
                        height: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            color: "#15182b",
                            fontWeight: "bold",
                            textAlign: "center",
                            maxWidth: "600px",
                            marginBottom: "20px",
                        }}
                    >
                        Meet Our Team
                    </Typography>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            justifyContent: "center",
                            paddingRight: {lg: "0px", xl: "20%" },
                            paddingLeft: {lg: "0px", xl: "20%" },
                        }}
                    >
                        {team.map((member, index) => (
                            <Grid
                                item
                                key={index}
                                xs={9} // Tam genişlik (mobil ekranlar için)
                                sm={6} // 2'li grup (tablet ve daha büyük ekranlar için)
                                md={3} // 3'lü grup (orta ekranlar için)
                            >
                                <Card
                                    sx={{
                                        width: { xs: 120, sm: 200, md: 250 }, // Ekran boyutuna göre genişlik
                                        height: { xs: 130, sm: 240, md: 280 }, // Ekran boyutuna göre yükseklik
                                        display: "flex",
                                        flexDirection: "column",
                                        backgroundColor: "#f3ecd8",
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        sx={{
                                            height: { xs: 90, sm: 160, md: 210 },
                                            objectFit: "contain",
                                        }}
                                        image={member.image}
                                        title={member.role}
                                    />
                                    <CardContent
                                        sx={{
                                            padding: "0px",
                                            paddingTop: "3px",
                                            backgroundColor: "#15182b",
                                        }}
                                    >
                                        <Typography
                                            variant="h5"
                                            component="div"
                                            sx={{
                                                margin: 0,
                                                textAlign: "center",
                                                color: "#f3ecd8",
                                                fontSize: { xs: "12px", sm: "18px", md: "20px" },
                                            }}
                                        >
                                            {member.name}
                                        </Typography>
                                    </CardContent>
                                    <CardContent
                                        sx={{
                                            padding: "0px",
                                            paddingTop: "0px",
                                            backgroundColor: "#1e233e",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            component="div"
                                            sx={{
                                                textAlign: "center",
                                                color: "rgba(243,236,216,0.85)",
                                                fontSize: { xs: "12px", sm: "18px", md: "20px" },
                                            }}
                                        >
                                            {member.role}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {/* Contact Section */}
                <Box
                    id="contact"
                    sx={{
                        height: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        padding: { xs: "16px", sm: "24px", md: "32px" }, // Küçük ekranlarda padding artışı
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            color: "#15182b",
                            fontWeight: "bold",
                            marginBottom: { xs: "40px", md: "100px" }, // Ekran boyutuna göre boşluk
                            fontSize: { xs: "24px", md: "36px" }, // Font boyutu dinamik
                            textAlign: "center",
                        }}
                    >
                        Contact Us
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: theme.spacing(4),
                        }}
                    >
                        <img
                            src={LogoPeople}
                            alt="Logo"
                            style={{
                                height: "400px",
                                maxWidth: "100%", // Görüntünün genişliği sınırlandırıldı
                                objectFit: "contain",
                                filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))",
                            }}
                        />
                        <Box
                            sx={{
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "flex-start",
                                textAlign: "center", // Küçük ekranlarda ortalanır
                                width: "100%",
                                maxWidth: "500px", // İçeriğin genişliği sınırlandırıldı
                            }}
                        >
                            <Typography
                                variant="h4"
                                sx={{
                                    color: "#15182b",
                                    fontWeight: "bold",
                                    marginBottom: "16px",
                                    fontSize: { xs: "20px", md: "28px" },
                                }}
                            >
                                Doin' Together Games
                            </Typography>
                            <Typography
                                variant="h5"
                                sx={{
                                    color: "#15182b",
                                    marginBottom: "8px",
                                    fontSize: { xs: "16px", md: "20px" },
                                }}
                            >
                                dointogethergames@gmail.com
                            </Typography>

                            <Box
                                sx={{
                                    marginTop: "30px",
                                    display: "flex",
                                    gap: "15px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <IconButton
                                    href="https://www.instagram.com/dointogethergames/"
                                    target="_blank"
                                    sx={{
                                        backgroundColor: "#f3ecd8",
                                        borderRadius: "12px",
                                        padding: "10px",
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                    }}
                                >
                                    <Instagram style={{ color: "#15182b" }} />
                                </IconButton>
                                <IconButton
                                    href="https://x.com/dointogether"
                                    target="_blank"
                                    sx={{
                                        backgroundColor: "#f3ecd8",
                                        borderRadius: "12px",
                                        padding: "10px",
                                    }}
                                >
                                    <X style={{ color: "#15182b" }} />
                                </IconButton>
                                <IconButton
                                    href="https://www.linkedin.com/company/dointogethergames/"
                                    target="_blank"
                                    sx={{
                                        backgroundColor: "#f3ecd8",
                                        borderRadius: "12px",
                                        padding: "10px",
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                    }}
                                >
                                    <LinkedIn style={{ color: "#15182b" }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </div>
        </ThemeProvider>
    );
};

export default App;
